import React from 'react';
import Form, { DateInput, FormActions, FormBody, SelectInput } from "../../../Form";
import { inject, observer } from 'mobx-react';
import { observable, action, toJS, computed } from 'mobx';
import moment from "moment";
import { analysis as api } from "../../../../actions/api";
import _ from 'lodash';
import Spinner from "../../../Spinner";
import {getDisplayDate} from '../../../../libs/date';
import { attachCookies } from 'superagent';

@inject('stationStore', 'parameterStore')
@observer
class StaffGauge extends React.Component {
  autoFillForm = process.env.NODE_ENV !== 'production';

  @observable isLoading = false;

  @observable filters = {
    station: this.autoFillForm ? 227 : '',
    parameter: this.autoFillForm ? 97 : '',
    dateFrom: moment().subtract(7, 'days'),
    dateTo: moment(),
  };

  @observable observations = null;

  componentWillMount() {
    const { stationStore, parameterStore } = this.props;

    if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
    if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();

  }

  @action onChangeFilters = (field, value) => this.filters[field] = value;
  @action onCompareStationSelect = item => item.value = !item.value;

  onView = (e) => {
    e.preventDefault();
    const { station, parameter, dateFrom, dateTo } = this.filters;

    if (!station || !parameter || !dateFrom || !dateTo) return null;

    this.isLoading = true;
    this.observations = null;

    api.fetchMore({ stations: station, parameters: parameter, date_from: dateFrom, date_to: dateTo })
      .then(res => {
        this.isLoading = false;
        this.observations = _.get(res, '[0].parameters[0].data', []).filter(item => {
          let time = getDisplayDate(item.time).split(' ')[1],
              hour = +time.split(':')[0],
              minute = +time.split(':')[1];
          return (hour === 8 || hour === 12 || hour === 16) && minute === 0;
        });
      }).catch(err => {
        this.context.notift.error({message: err.toString()});
        this.isLoading = false;
      })

  };

  
  onDownload = (e) => {
    e.preventDefault();
    if (!this.observations) return;

    let textToSave = '';
    let stationIndex = _.get(_.get(this.props.stationStore.findById(this.filters.station), 'meta_data', []).find(item => item.name === 'Station Index'), 'value', '');
    let years = this.observations.reduce((acc, {time}) => {
      let year = getDisplayDate(time).split('-')[0];
      if(!acc.find(item => item === year)) acc.push(year);
      return acc;
    }, []);
    textToSave = `Staff Gaauge Reading of Station: ${stationIndex} in m\n${years.join('\n')}\n`;
    this.observations.forEach(({time, value}) => {
      textToSave = textToSave.concat(getDisplayDate(time, {format: 'DD/MMM/YYYY,HH:mm'}) + ',' + Math.floor(value * 100)/100 + '\n');
    });

    let hiddenElement = document.createElement('a');
    document.body.appendChild(hiddenElement);
    let csvData = new Blob([textToSave], {type: 'text/txt'});
    hiddenElement.href = URL.createObjectURL(csvData);
    // hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
    hiddenElement.target = '_blank';
    hiddenElement.download = `GHT_${stationIndex}.txt`;
    hiddenElement.click();
  };

  _renderTable = observations => {
    if(!observations) return null;
    return(<div>
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {observations.map((item, index) => (
            <tr key={`staff-guage-table-row-${index}`}>
              <td>{getDisplayDate(item.time)}</td>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>)
  }

  render() {
    const { stationStore, parameterStore } = this.props;
    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput label='Station' options={stationStore.items} fields={{ value: 'id', label: 'name' }}
              value={this.filters.station} onChange={e => this.onChangeFilters('station', +e.target.value)} />
            <SelectInput label='Parameter' options={parameterStore.items} fields={{ value: 'id', label: 'name' }}
              value={this.filters.parameter} onChange={e => this.onChangeFilters('parameter', +e.target.value)}
              filterOptions={parameterStore.filterParameters} />
            <DateInput
              label={'Date From'}
              type="datetime-local"
              value={moment(this.filters.dateFrom).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeFilters('dateFrom', e.target.value)}
            />
            <DateInput
              label={'Date To'}
              type="datetime-local"
              value={moment(this.filters.dateTo).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeFilters('dateTo', e.target.value)}
            />
          </FormBody>
          <FormActions>
            <button onClick={this.onView}>View</button>
            <button onClick={this.onDownload}>Download</button>
          </FormActions>
        </Form>
        {this.isLoading && <Spinner />}
        {this._renderTable(this.observations)}
      </div>
    );
  }
}

export default StaffGauge;


// WEBPACK FOOTER //
// ./src/components/Analysis/Tools/StaffGauge/StaffGauge.js